import { createSlice } from '@reduxjs/toolkit';
import { HealthPlanState } from './types';

const initialState: HealthPlanState = {
  selectedHealthTab: 0,
  selectedHealthType: 'All'
};

const healthPlanSlice = createSlice({
  name: 'healthPlan',
  initialState,
  reducers: {
    setHealthPlanTab: (state, action) => {
      state.selectedHealthTab = action.payload;
    },
    setHealthPlanType: (state, action) => {
      state.selectedHealthType = action.payload;
    }
  }
});

export const { setHealthPlanTab, setHealthPlanType } = healthPlanSlice.actions;

export default healthPlanSlice.reducer;
